<template>
    <e-charts
        :options="chartOptions"
        :init-options="initOptions"
        ref="map"
        autoresize
    />
</template>
<script>
import barMixin from '@/views/common/m-chart-bar'

// 空置天数
export default {
    mixins: [barMixin],
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        chartOptions() {
            var color = ['#60CE9F', '#DDC424', '#F4A456', '#ED475B']

            return {
                title: {
                    text: '空置天数',
                    textStyle: {
                        color: '#7F7F7F',
                        fontSize: 12,
                    },
                },
                tooltip: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                grid: {
                    top: 28,
                    left: 33,
                    right: '6%',
                    bottom: 0,
                },
                label: {
                    show: true,
                    position: 'right',
                    textStyle: {
                        fontSize: 12,
                    },
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    show: false,
                },
                yAxis: {
                    type: 'category',
                    data: ['<10', '11-20', '21-30', '>30'],
                    inverse: true, // 反向坐标轴
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        align: 'right',
                    },
                    splitLine: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: 'days',
                        type: 'bar',
                        data: this.value,
                        itemStyle: {
                            color(params) {
                                return color[params.dataIndex]
                            },
                            barBorderRadius: [0, 5, 5, 0],
                        },
                        barWidth: 10,
                    },
                ],
            }
        },
    },
}
</script>
